import css from './media-button.css'

const ALLOWED_PROVIDERS = ['youtube', 'vimeo']

export default function(media) {
    if (!media || !media.provider_name || ALLOWED_PROVIDERS.indexOf(media.provider_name) < 0) {
        return ''
    }

    const { provider_name } = media
    const providerLabel = provider_name.charAt(0).toUpperCase() + provider_name.slice(1)
    return `<div class="${css.mediaButton}"
            onclick="toggleMediaEmbed();trackEvent('Click', 'Play ${providerLabel}');"
            data-haslabel>
            <div class="${css[provider_name]}"></div>
            <div data-label>Watch</div>
        </div>`
}
